import script from "./externalLink.vue?vue&type=script&lang=js"
export * from "./externalLink.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__